import Vue from 'vue'
import App from './App.vue'

import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
Vue.prototype.$ = $;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router/index.js';
import VueI18n from 'vue-i18n';

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

// 谷歌地图
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAGo7yhLGXEpyDX2Wbyee7rnOkj87IE16g',
    libraries: 'places' // 可选的：包括其他库，如'places'等。
  }
})


Vue.config.productionTip = false
Vue.use(ElementUI);
// 多语言配置
Vue.use(VueI18n);
function loadLocaleMessages() {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'en', // 设置默认语言环境 process.env.VUE_APP_I18N_LOCALE
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en', // 设置备选语言环境
  messages: loadLocaleMessages() // 设置加载的语言信息
});
Vue.prototype.$bus = new Vue();
i18n.vm.$watch('locale', (newVal) => {
  Vue.prototype.$bus.$emit('locale-change', newVal)
})

new Vue({
  router,
  i18n,
  el: '#app',
  render: h => h(App),
})
